import dayjs from "@shared/dayjs";

const valueOrZero = (value) => value ? value : 0

const lastVisit = (value) => value ? dayjs(value).fromNow() : 'NEVER'

const visits = (value) => value ? value : 'NONE'

export {
  valueOrZero,
  lastVisit,
  visits
}
